import axios from 'axios'
import {AuthenticatedUser, serverResponse} from './_models'
import {FormStructure} from '../../formulario/newQuestions'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/get-authenticated-user`
export const LOGIN_URL = `${API_URL}/auth/login`
export const FIRST_ACCESS_CHECK_EMAIL_URL = `${API_URL}/auth/first-access/check-email`
export const FIRST_ACCESS_SET_PASSWORD_URL = `${API_URL}/auth/first-access/set-password`
export const CHANGE_PASSWORD_URL = `${API_URL}/auth/change-password`
export const IMPERSONATE_URL = `${API_URL}/auth/impersonate`
export const STOP_IMPERSONATION_URL = `${API_URL}/auth/impersonation/stop`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`
// form
export const GET_ALL_QUESTIONS = `${API_URL}/questions`
export const SAVE_QUESTIONS = `${API_URL}/questions/answers/save`
export const SAVE_QUESTIONS_FOR_STUDENTS = `${API_URL}/questions/answers/save`

export const GET_ALL_TEACHER_QUESTIONS = `${API_URL}/teacher/questions`
export const SAVE_TEACHER_QUESTIONS = `${API_URL}/teacher/questions/answers/save`
export const SAVE_TEACHER_QUESTIONS_FOR_STUDENT = `${API_URL}/teacher/questions/answers/save`

export const GET_ALL_REPORTS_VALUES = `${API_URL}/analytics/overview`
export const USER_INFOS = `${API_URL}/users`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<serverResponse>(LOGIN_URL, {
    email,
    password,
  })
}

export function checkFirstAccessEmail(email: string) {
  return axios.post(FIRST_ACCESS_CHECK_EMAIL_URL, {
    email,
  })
}

export function setFirstAccessPassword(
  email: string,
  password: string,
  passwordConfirmation: string
) {
  return axios.post<serverResponse>(FIRST_ACCESS_SET_PASSWORD_URL, {
    email,
    password,
    password_confirmation: passwordConfirmation,
  })
}

export function changePassword(password: string, passwordConfirmation: string) {
  return axios.put(CHANGE_PASSWORD_URL, {
    password,
    password_confirmation: passwordConfirmation,
  })
}

export function impersonateUser(userId: number) {
  return axios.post(`${IMPERSONATE_URL}/${userId}`)
}

export function stopImpersonation() {
  return axios.post(STOP_IMPERSONATION_URL)
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.get<AuthenticatedUser>(GET_USER_BY_ACCESSTOKEN_URL)
}

export async function getAllFormQuestions() {
  const resp = await axios.get(GET_ALL_QUESTIONS)
  return resp.data
}

export async function getAllFormAnswerQuestions(studentId: number) {
  const resp = await axios.get(GET_ALL_QUESTIONS + `/${studentId}`)
  return resp.data
}

export async function getAllTeachersFormQuestions() {
  const resp = await axios.get(GET_ALL_TEACHER_QUESTIONS)
  return resp.data
}

export async function getAllTeachersFormAnswerQuestions(stundentId: number) {
  const resp = await axios.get(GET_ALL_TEACHER_QUESTIONS + `/${stundentId}`)
  return resp.data
}

export function saveAnswers(answers: FormStructure[]) {
  return axios.post(SAVE_QUESTIONS, {
    ...answers,
  })
}
export function saveAnswersForStudent(answers: FormStructure[], studentId: number) {
  return axios.post(SAVE_QUESTIONS_FOR_STUDENTS + `/${studentId}`, {
    ...answers,
  })
}

export function saveTeachersAnswers(answers: FormStructure[]) {
  return axios.post(SAVE_TEACHER_QUESTIONS, {
    ...answers,
  })
}

export function saveTeachersAnswersForStudent(answers: FormStructure[], studentId: number) {
  return axios.post(SAVE_TEACHER_QUESTIONS_FOR_STUDENT + `/${studentId}`, {
    ...answers,
  })
}

export function getReportsValues(projectId?: number) {
  return axios.get(GET_ALL_REPORTS_VALUES,{
    params: {
      project_id: projectId
    }
  })
}

export function userParams(userId: number) {
  return axios.get(`${USER_INFOS}/`+userId)
}
